<template>
  <div>
    <slot />
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'FouAccordion',
}
</script>
